import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-white transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 恋爱影视作品封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {typeof rank === "number" && (
          <span className="absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-xs font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-primary-300"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-0 bottom-0 truncate bg-gradient-to-t from-foreground-950/80 to-transparent px-2 pb-1.5 pt-4 text-xs text-background-50">
          {movie.updateStatus}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950">{movie.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-600">
          {movie.type} · {movie.year} · {movie.region}
        </p>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.actors.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}